import { baseUrl } from 'volto-ebc-radiomec/utils/api';

export type LatestContentItem = {
  '@id': string;
  audio?: string | null;
  datePublished?: string;
  image?: string | null;
  pogramTitle?: string;
  programUrl?: string;
  title?: string;
};

export async function getLatestContent(page = 1): Promise<LatestContentItem[]> {
  try {
    const url =
      page > 1
        ? `${baseUrl}/@content-latest?page=${page}`
        : `${baseUrl}/@content-latest`;

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(
        `Erro ao buscar conteúdo mais recente: ${response.status}`,
      );
    }

    const data = await response.json();
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error('Falha ao buscar conteúdo mais recente:', error);
    return [];
  }
}
